import * as React from 'react'

import { LoginForm, LoginFormSSO } from 'main/components/common/AuthModal'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../../../common'
import { i18nKeyPrefix } from '../../../../../../i18n'

import { ICoreProps, IExtraProps, StepType } from '../types'
import { LoginContainer, StyledText } from './Login.styles'

const PRE = `${i18nKeyPrefix}-CTA-ENROLL-STEPS-LOGIN`

export default function Login(props: ICoreProps & IExtraProps) {
  const { onAuth, changeStep } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  return <LoginContainer>{renderForm()}</LoginContainer>

  function renderForm() {
    if (isSSO) return <LoginFormSSO />

    return (
      <>
        <StyledText>{t(`${PRE}-TEXT`)}</StyledText>

        <LoginForm
          cta="Login"
          onComplete={(credentials: CredentialsFields) =>
            onAuth(credentials).then(() => changeStep())
          }
          onRequestSignUp={() => changeStep(StepType.SIGN_UP)}
        />
      </>
    )
  }
}
